export enum CmsKeys {
  APPLICATIONS_CONFIG = 'applications',
  APPLICATIONS_ORGANIZE = 'applicationsOrder',
  FIELDS_CONFIG = 'fields',
  FIELDS_ORGANIZE = 'fieldsOrder',
  METRICS_CONFIG = 'metrics',
  METRICS_ORGANIZE = 'metricsOrder'
}
